<template>
    <nav id="open-navigation-global" :class="{ 'is-dark': dark }">
        <div class="is-top">
          <NavMenu :dark="dark" :menu="menu" />
        </div>
    </nav>
</template>

<script setup lang="ts">

  import { computed } from "vue";

  import globalMenu from '@/menus/global-public';
  import NavMenu from '@/components/NavMenu.vue';
  import type Menu from "@/use/Menu";

  const props = withDefaults(defineProps<{
    dark?: boolean,
  }>(), {
    dark: false,
  });

  const menu = computed<Menu>(() => {
    return globalMenu({
      hideTitles: true,
    });
  });

</script>

<style lang="scss" scoped>
    #open-navigation-global {
        background: var(--nav-background);
        color:var(--nav-text);
        display: flex;
        flex-shrink: 0;
        height: 100%;
        width: 73px;
        flex-direction: column;
        justify-content: space-between;
        padding: 5px 12.5px;
        z-index: 2000;
    }
</style>
